export function mapUrlPathToOvpPath(path: string) {
  switch (path) {
    case '/forside':
      return '/';
    default:
      return path;
  }
}
export function mapOvpPathToUrlPath(path: string) {
  switch (path) {
    case '/':
      return '/forside';
    default:
      return path;
  }
}
